import { ReactNode } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover.tsx';
import TagPicker, {
  TagPickerProps,
} from '@/features/dashboard/tags/components/TagPicker.tsx';

/**
 * Table-cell wrapper for the tag picker. `children` is the clickable trigger
 * (the cell's chip strip). Clicks are kept from bubbling to the table row.
 */
const TagPickerPopover = ({
  targetType,
  targetId,
  onMutated,
  children,
}: TagPickerProps & { children: ReactNode }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-72"
        onClick={(e) => e.stopPropagation()}
      >
        <TagPicker
          targetType={targetType}
          targetId={targetId}
          onMutated={onMutated}
        />
      </PopoverContent>
    </Popover>
  );
};

export default TagPickerPopover;
